export default "__VITE_ASSET__efyiVf9N__"